export default "__VITE_ASSET__a59550ac__"